import React from 'react'
import { GoogleAd } from '../components/ads/GoogleAd'
import FullScreenWrapper from './FullScreenWrapper'
import { useScreen } from '../contexts/screen.provider'
import EndedInterviewScorePage from './EndedInterviewScorePage'

const EndedInterviewScore = () => {
    const { isMobile, isDesktop } = useScreen()

    return (
        <div className="w-full overflow-hidden  h-screen overflow-x-hidden  custom-scrollbar bg-white dark:bg-[#242424] flex flex-col ">
            <main className="flex gap-2  tablet:px-4 px-0   w-full   flex-col items-center tablet:items-start justify-stretch  tablet:flex-row flex-grow relative">
                {
                    !isMobile && <GoogleAd />

                }
                <FullScreenWrapper>
                    <EndedInterviewScorePage />
                </FullScreenWrapper>
                {
                    isDesktop
                        ?
                        <GoogleAd />
                        : <div className="h-full w-full ">
                            <GoogleAd />
                        </div>
                }
            </main>
        </div>
    )
}

export default EndedInterviewScore